"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiSigProposalAction = exports.ProposalStatus = void 0;
var ProposalStatus;
(function (ProposalStatus) {
    ProposalStatus["Invalid"] = "Invalid";
    ProposalStatus["Active"] = "Active";
    ProposalStatus["Expired"] = "Expired";
    ProposalStatus["Successful"] = "ExecutionSuccessful";
    ProposalStatus["Failed"] = "ExecutionFailed";
    ProposalStatus["Rejected"] = "Rejected";
})(ProposalStatus = exports.ProposalStatus || (exports.ProposalStatus = {}));
var MultiSigProposalAction;
(function (MultiSigProposalAction) {
    MultiSigProposalAction["Approve"] = "approve";
    MultiSigProposalAction["Reject"] = "reject";
})(MultiSigProposalAction = exports.MultiSigProposalAction || (exports.MultiSigProposalAction = {}));
//# sourceMappingURL=types.js.map